import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What qualifications do your Android developers possess?",
    answer: `<p> Our developers are experts in Kotlin, Java, and Android Studio, with extensive experience in delivering high-quality Android applications using the latest tools and technologies.</p>`,
  },
  {
    question: "How do you ensure the quality of the developers you provide?",
    answer: `<p> We have a rigorous vetting process that includes technical assessments, coding tests, and interviews. Only developers with exceptional technical skills and problem-solving abilities are selected.</p>`,
  },
  {
    question: "Can I hire developers for short-term projects?",
    answer: `<p>Yes, we offer flexible hiring options for both short-term and long-term projects to meet your unique business needs.</p>`,
  },
  {
    question: "How do I communicate with the developers I hire?",
    answer: `<p>Communication is facilitated through various channels such as email, chat, video calls, and project management tools like Slack, Trello, or Jira to keep you updated on project progress.</p>`,
  },
  {
    question: "What is your pricing model for hiring Android developers?",
    answer: `<p>Our pricing is flexible and competitive, based on the developer's experience and project duration. We offer hourly rates, fixed-price contracts, or retainer agreements with no hidden fees.</p>`,
  },
  {
    question:
      "Do you provide ongoing support and maintenance after the project is completed?",
    answer: `<p>Yes, we offer comprehensive support and maintenance services to ensure your app runs smoothly after launch. Our developers assist with updates, bug fixes, and new feature development as needed.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Hire Android App Developers FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
